import { render, staticRenderFns } from "./InfoBreak.vue?vue&type=template&id=2876111c&"
import script from "./InfoBreak.vue?vue&type=script&lang=js&"
export * from "./InfoBreak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports